

document.addEventListener("DOMContentLoaded", function () {
  const headings = document.querySelectorAll(".gravix-footer .footer-column-heading");
  const mobileQuery = window.matchMedia("(max-width: 768px)");

  function collapseAll() {
    document.querySelectorAll(".footer-column.open")
      .forEach(col => col.classList.remove("open"));
  }

  // Initial state: if we're on mobile, keep all collapsed
  if (mobileQuery.matches) {
    collapseAll();
  }

  // Clicking a heading toggles ONLY that column
  headings.forEach(heading => {
    heading.addEventListener("click", function () {
      if (!mobileQuery.matches) return; // only on mobile

      const column = this.parentElement;
      column.classList.toggle("open");  // <-- no closeAll()
    });
  });

  // When resizing between desktop/mobile
  mobileQuery.addEventListener("change", function (e) {
    if (e.matches) {
      // entering mobile -> collapse all by default
      collapseAll();
    } else {
      // entering desktop -> remove open (CSS shows everything)
      collapseAll();
    }
  });
});
